import {GroupAvatarsTheme, TagAvatarTheme} from '../../Components/Avatars/themes';

export const AvatarsThemesEnum = {
  GroupAvatars: {
    theme: GroupAvatarsTheme,
  },
  TagAvatar: {
    theme: TagAvatarTheme,
  },
};
